/* src/app/shared/components/flow-button-v2/flow-button-v2.component.scss */
.flow-button {
  display: inline-flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  min-width: max-content;
  box-sizing: border-box;
  border: none;
  outline: none;
  position: relative;
  transition:
    background-color 0.2s,
    box-shadow 0.15s,
    transform 0.15s;
}
.flow-button.loading {
  cursor: default;
}
.flow-button .flow-button-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}
.flow-button .flow-button-icon img {
  width: 100%;
  height: 100%;
}
.flow-button p {
  line-height: 24px;
}
.flow-button.primary {
  background-color: #4568d0;
  color: white;
}
.flow-button.primary img {
  filter: brightness(0) invert(1);
}
.flow-button.primary p {
  color: white !important;
}
.flow-button.primary:not(.loading):hover {
  background-color: #5580dc;
}
.flow-button.primary:focus-visible {
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.2),
    0 0 0 1px #fff,
    0 0 0 3px rgba(89, 113, 197, 0.5) !important;
}
.flow-button.secondary {
  background-color: #f4f4f5;
  color: #18181b;
}
.flow-button.secondary:not(.loading):hover {
  background-color: #e4e4e7;
}
.flow-button.secondary:focus-visible {
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.2),
    0 0 0 1px #fff,
    0 0 0 3px rgba(89, 113, 197, 0.5) !important;
}
.flow-button.destructive {
  background-color: #b91c1c;
  color: white;
}
.flow-button.destructive img {
  filter: brightness(0) invert(1);
}
.flow-button.destructive p {
  color: white !important;
}
.flow-button.destructive:not(.loading):hover {
  background-color: #dc2626;
}
.flow-button.destructive:focus-visible {
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.2),
    0 0 0 1px #fff,
    0 0 0 3px rgba(89, 113, 197, 0.5) !important;
}
.flow-button.no-border {
  border: none !important;
}
.flow-button.ghost {
  background-color: transparent !important;
}
.flow-button.destructive.ghost {
  color: #b91c1c !important;
}
.flow-button.destructive.ghost p {
  color: #b91c1c !important;
}
.flow-button.destructive.ghost img {
  filter: brightness(0) saturate(100%) invert(17%) sepia(31%) saturate(6219%) hue-rotate(345deg) brightness(89%) contrast(99%);
}
.flow-button.destructive.ghost:not(.loading):hover {
  background-color: #fef2f2 !important;
}
.flow-button.primary.ghost {
  color: #4568d0 !important;
}
.flow-button.primary.ghost p {
  color: #4568d0 !important;
}
.flow-button.primary.ghost img {
  filter: brightness(0) saturate(100%) invert(32%) sepia(84%) saturate(940%) hue-rotate(200deg) brightness(98%) contrast(85%);
}
.flow-button.primary.ghost:not(.loading):hover {
  background-color: #f1f5fd !important;
}
.flow-button.secondary.ghost:not(.loading):hover {
  background-color: #f4f4f5 !important;
}
.flow-button.disabled {
  background-color: #f4f4f5 !important;
  cursor: default !important;
  color: #a1a1aa !important;
  box-shadow: none !important;
}
.flow-button.disabled img {
  filter: brightness(0) saturate(100%) invert(87.5%);
}
.flow-button.disabled p {
  color: #a1a1aa !important;
}
.flow-button.disabled:hover {
  background-color: #f4f4f5 !important;
}
.flow-button.disabled:focus-visible {
  box-shadow: none;
}
.flow-button.large {
  padding: 12px 16px;
  height: 48px;
  min-width: 48px;
  border-radius: 12px;
}
.flow-button.medium {
  padding: 8px 12px;
  height: 40px;
  min-width: 40px;
  border-radius: 8px;
}
.flow-button.small {
  padding: 2px 8px;
  height: 32px;
  min-width: 32px;
  border-radius: 8px;
}
.flow-button.iconOnly {
  padding: 0 !important;
}
.flow-button.iconOnly.small {
  padding: 4px !important;
}
.flow-button.iconOnly.medium {
  padding: 8px !important;
}
.flow-button.iconOnly.large {
  padding: 12px !important;
}
.flow-button .flow-button-content {
  display: contents;
}
.flow-button .flow-button-content.invisible {
  visibility: hidden;
}
.flow-button .flow-button-loader ::ng-deep .flow-loader {
  position: absolute;
}
/*# sourceMappingURL=flow-button-v2.component.css.map */
